/** Purchasable top-up range, in USD. The backend rejects anything below the minimum. */
export const MIN_CREDIT_PRICE = 10;
export const MAX_CREDIT_PRICE = 10000;

export const CREDITS_TO_IMAGES_RATIO = 2.5;

export const CREDITS_TO_VIDEO_SECONDS_RATIO = 0.1666666;

/**
 * Rough "what can I make with this" estimate shown under the amount. Both figures describe the same
 * credits spent in full on one media type, so they are alternatives ("or"), not a sum.
 */
export function estimateGenerations(credits: number): { images: number; videoSeconds: number } {
  return {
    images: Math.round(credits * CREDITS_TO_IMAGES_RATIO),
    videoSeconds: Math.round(credits * CREDITS_TO_VIDEO_SECONDS_RATIO),
  };
}
